/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {Component, Prop, Vue} from 'vue-property-decorator';
import {Getter} from 'vuex-class';

/**
 * Site masthead component.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
@Component({
    name: 'c-masthead',
})
export default class Masthead extends Vue {
    // Settings masthead
    @Getter('mastheadImage', {namespace: 'settingsModule'})
    public mastheadImage!: string;

    @Prop(String) private title!: string;
    @Prop(String) private image!: string;

}
